import React from 'react';
import RequestPageIcon from '@mui/icons-material/RequestPage';
import CurrencyExchangeTwoToneIcon from '@mui/icons-material/CurrencyExchangeTwoTone';
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';
import DashboardIcon from '@mui/icons-material/Dashboard';
import LockResetIcon from '@mui/icons-material/LockReset';

export const LinksMenu = [
    {
        label: "Dashboard",
        url: "/dashboard",
        view: "dashboard",
        icon: <DashboardIcon color='primary' />
    },
    {
        label: "Fatura",
        url: "/fatura",
        view: "fatura",
        roles: ["ROLE_FATURAS_CONSOLIDADORA"],
        icon: <RequestPageIcon color='primary' />
    },
    {
        label: "Reembolso",
        url: "/reembolso",
        view: "reembolso",
        roles: ["ROLE_REEMBOLSO"],
        icon: <CurrencyExchangeTwoToneIcon color='primary' />
    },
    {
        label: "Configurações",
        url: "/sistema",
        view: "config",
        roles: ["ROLE_REEMBOLSO"],
        icon: <MiscellaneousServicesIcon color='primary' />
    },
    {
        label: "Redefinir Senha",
        url: "/redefinirSenha",
        view: "resetSenha",
        icon:<LockResetIcon color='primary'/>
    },
];

const urlBackend = process.env.REACT_APP_BACKEND_URL;

export { urlBackend }

